module.exports = __webpack_public_path__ + "static/media/jackson.d0058691.jpg";